import { baseSplitApi } from "../baseApi";
import { newLoginTag } from "../userAuth";

const addUserDetailsPath = '/attendance/userdetails';

const userDetailsTag = 'USERDETAILS'

export const addUserDetailsApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        addUserDetails: build.mutation({
            query: (userDetailsData) => {
                return {
                    url: addUserDetailsPath,
                    method: 'PUT',
                    body: userDetailsData
                }
            },
            invalidatesTags: [userDetailsTag]
        }),
        getUserDetails: build.query({
            query: () => {
                return {
                    url: addUserDetailsPath,
                    method: 'GET'
                }
            },
            providesTags: [userDetailsTag, newLoginTag]
        })
    }),
    overrideExisting: false,
}
);

export const { useAddUserDetailsMutation, useGetUserDetailsQuery } = addUserDetailsApi;
